import React from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-outer-wrapper">
        <div aria-hidden="true" className="footer-gold-rain"></div>
        <div className="footer-inner-content">
          <div className="footer-branding-block">
            <img
              alt={props.imageAlt}
              src={props.imageSrc}
              className="footer-image"
            />
            <p className="footer-brand-tagline">
              <span>Sudah Menjadi Situs Tepercaya Selama</span>
              <br></br>
              <span>Lebih dari 5 Tahun</span>
              <br></br>
              Exclusive High-End Luxury Experience
            </p>
          </div>
          <nav aria-label="Footer Navigation" className="footer-navigation">
            <ul className="footer-nav-list">
              <li className="footer-nav-item">
                <a href="#">
                  <div className="footer-nav-link">
                    <span>Home</span>
                  </div>
                </a>
              </li>
              <li className="footer-nav-item">
                <a
                  href="https://t.ly/Ads-angka"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="footer-nav-link">
                    <span>Daftar</span>
                  </div>
                </a>
              </li>
              <li className="footer-nav-item">
                <a
                  href="https://t.ly/Ads-angka"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="footer-thq-footer-nav-link-elm3 footer-nav-link">
                    <span>Login</span>
                  </div>
                </a>
              </li>
              <li className="footer-nav-item">
                <a
                  href="https://6angka138.com/promotion"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="footer-thq-footer-nav-link-elm4 footer-nav-link">
                    <span>Promotions</span>
                  </div>
                </a>
              </li>
              <li className="footer-nav-item"></li>
            </ul>
          </nav>
          <div className="footer-social-connect">
            <a href="#">
              <div aria-label="Facebook" className="footer-social-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </a>
            <a href="#">
              <div aria-label="Instagram" className="footer-social-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="2"
                      y="2"
                      rx="5"
                      ry="5"
                      width="20"
                      height="20"
                    ></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                  </g>
                </svg>
              </div>
            </a>
            <a href="#">
              <div aria-label="Twitter" className="footer-social-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </a>
          </div>
          <div className="footer-security-badges">
            <div className="footer-badge-item">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <span className="footer-badge-text">Secure SSL Encryption</span>
            </div>
          </div>
          <div className="footer-legal-bar">
            <p className="footer-copyright">
              &amp;copy; 2026 ANGKA138. All Rights Reserved.
            </p>
            <div className="footer-legal-links">
              <a href="#">
                <div className="footer-legal-link">
                  <span>Terms &amp; Conditions</span>
                </div>
              </a>
              <a href="#">
                <div className="footer-legal-link">
                  <span>Privacy Policy</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-effects">
(function(){
  const createGoldParticles = () => {
    const footer = document.querySelector(".footer-outer-wrapper")
    const rainContainer = document.querySelector(".footer-gold-rain")

    if (!footer || !rainContainer) return

    const particleCount = 25

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement("div")
      const size = Math.random() * 2 + 1
      const duration = Math.random() * 3 + 4
      const delay = Math.random() * 5
      const left = Math.random() * 100

      particle.style.cssText = \`
      position: absolute;
      top: -20px;
      left: \${left}%;
      width: \${size}px;
      height: \${size * 10}px;
      background: linear-gradient(to bottom, transparent, var(--color-secondary));
      opacity: \${Math.random() * 0.5 + 0.2};
      border-radius: 2px;
      pointer-events: none;
      animation: goldRainFall \${duration}s linear \${delay}s infinite;
    \`

      rainContainer.appendChild(particle)
    }
  }

  const styleSheet = document.createElement("style")
  styleSheet.textContent = \`
  @keyframes goldRainFall {
    0% { transform: translateY(-100px); opacity: 0; }
    20% { opacity: 0.6; }
    80% { opacity: 0.6; }
    100% { transform: translateY(600px); opacity: 0; }
  }
\`
  document.head.appendChild(styleSheet)

  createGoldParticles()
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Footer.defaultProps = {
  imageSrc: '/hd_restoration_result_image-200h.png',
  imageAlt: 'image',
}

Footer.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
}

export default Footer
